import { Button, ButtonType, ButtonSize, IconName } from '@hills-design-system/components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { TranslationKeyEnum } from '../types/constants';
import { gigyaSSOLogin } from '../services/gigya';
import { getAssetUrl } from '../utils/assetUrl';
import { getFoodShelterLoveRedirectUrl } from '../utils/redirectUrl';

const UnauthorizedHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogin = async () => {
    const redirectUrl = getFoodShelterLoveRedirectUrl();
    await gigyaSSOLogin(redirectUrl);
  };

  return (
    <nav className="w-full bg-white px-6" role="navigation" aria-label={t(TranslationKeyEnum.MainNavigation)}>
      <div className="flex items-center justify-between py-4 max-w-7xl mx-auto mt-12">
        <Button
          label={t(TranslationKeyEnum.Login)}
          icon={IconName.User}
          type={ButtonType.Tertiary}
          size={ButtonSize.Medium}
          onClick={handleLogin}
          className="login-btn-left-icon hover:bg-transparent hover:!text-blue-700 cursor-pointer text-blue-600 font-medium"
          aria-label={t(TranslationKeyEnum.Login)}
        />

        <button
          onClick={() => navigate('/')}
          className="absolute left-1/2 -translate-x-1/2 flex items-center justify-center hover:opacity-80 transition-opacity"
          aria-label={t(TranslationKeyEnum.FoodShelterLoveLogo)}
        >
          <img
            src={getAssetUrl('fsl-logo.svg')}
            alt={t(TranslationKeyEnum.FoodShelterLoveLogo)}
            className="h-12 w-auto"
            loading="eager"
          />
        </button>

        <Button
          label={t(TranslationKeyEnum.Apply)}
          size={ButtonSize.Medium}
          onClick={() => navigate('/apply')}
          className="cursor-pointer bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-2.5 rounded-md"
          aria-label={t(TranslationKeyEnum.Apply)}
        />
      </div>
    </nav>
  );
};

export default UnauthorizedHeader;
